export const PageScrollObserver = {
  mounted() {
    this.observedPages = new Set();
    this.observer = new IntersectionObserver(
      (entries) => {
        const entered = entries
          .filter((entry) => entry.isIntersecting)
          .map((entry) => Number(entry.target.dataset.pageIndex));

        if (entered.length > 0) {
          this.pushEventTo(this.el, "page_scrolled_into_view", { page_index: Math.min(...entered) });
        }
      },
      { threshold: 0 }
    );
    this.observePages();
  },

  updated() {
    this.observePages();
  },

  observePages() {
    this.el.querySelectorAll("[data-page-index]").forEach((page) => {
      if (this.observedPages.has(page)) return;
      this.observedPages.add(page);

      const img = page.querySelector("img");
      if (img && img.complete) {
        this.observer.observe(page);
      } else if (img) {
        img.addEventListener("load", () => this.observer.observe(page), { once: true });
      } else {
        this.observer.observe(page);
      }
    });
  },

  destroyed() {
    this.observer.disconnect();
  },
};
